// 调用
/*
** @params
** path: 请求的路径
** preload: 请求的参数
** cachetype: 'no'[本次请求不走缓存过滤] ‘str’[同一个路径缓存一条] ‘arr’[同一个路径缓存多条]
*/
// cacheAgain.setAgainAgent('/index', {page: 1}, {data:{code: 0}}, 'arr')
// cacheAgain.getAgainAgent('/index', {page: 1}, 'arr')
// if (cacheAgain.resPromise) {
//   return cacheAgain.resPromise
// } else {
//   return axois.get()
// }
export default class againCache {
  constructor () {
    this.author = 'Hansin'
    this.cacheList = []
  }

  getCache (path, preload) {
    let copyPro = {}
    let newPath = ''
    if (typeof preload === 'object') {
      preload = JSON.stringify(preload)
      copyPro = JSON.parse(preload)
      if (copyPro.appointTimeStamp) {
        delete copyPro.appointTimeStamp
      }
      if (copyPro.conventionSecret) {
        delete copyPro.conventionSecret
      }

      let newArray = []
      for (let i in copyPro) {
        newArray.push(encodeURIComponent(i) + '=' + encodeURIComponent(copyPro[i]))
      }
      newPath = path + '?' + newArray.join('&')
      let getItem = JSON.parse(localStorage.getItem(newPath))
      if (getItem) {
        let nowTime = new Date().getTime()
        let time = nowTime - getItem.time
        if (time > 1000 * 60 * 30) {
          for (let i = 0; i < localStorage.length; i++) {
            if (localStorage.key(i).includes(path)) {
              localStorage.removeItem(localStorage.key(i))
            }
          }
          return null
        }
        return getItem.res
      } else {
        return null
      }
    } else {
      copyPro = preload
      newPath = path
      let getItem = JSON.parse(localStorage.getItem(path))
      if (getItem) {
        let nowTime = new Date().getTime()
        let time = nowTime - getItem.time
        if (time > 1000 * 60 * 30) {
          for (let i = 0; i < localStorage.length; i++) {
            if (localStorage.key(i).includes(path)) {
              localStorage.removeItem(localStorage.key(i))
            }
          }
          return null
        }
        return getItem.res
      } else {
        return null
      }
    }
  }

  setCache (path, preload, res) {
    let newPath = ''
    var setItem = {}
    if (typeof preload === 'object') {
      let newArray = []
      for (let i in preload) {
        newArray.push(encodeURIComponent(i) + '=' + encodeURIComponent(preload[i]))
      }
      newPath = path + '?' + newArray.join('&')
    } else {
      newPath = path
    }
    let getItem = JSON.parse(localStorage.getItem(newPath))
    if (getItem === '' || getItem === null || JSON.stringify(getItem) === '{}') {
      setItem.time = new Date().getTime()
      setItem.res = res
    } else {
      for (let i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i).includes(path)) {
          localStorage.removeItem(localStorage.key(i))
        }
      }
    }
    localStorage.setItem(newPath, JSON.stringify(setItem))
  }
}

// jiami 请不要删除
export function KeyMove () {
  return 'WyIiLCAielF6TlQiLCAiMiIsICJ6QXoiLCAiaiIsICJ6IiwgInpFek56IiwgIjQiLCAiemswIiwgIlRWaE5EIiwgIjBZalExTkRZPSJd'
}
